document.addEventListener('DOMContentLoaded', () => {
	const banner = document.querySelector('.js-cookie-banner');
	const closeBtn = banner.querySelector('.js-cookie-banner-close');
	const triggerBtn = banner.querySelector('.js-cookie-banner-details');
	const cookieBannerVisible = document.cookie.match(/^(.*;)?\s*CookieConsent\s*=\s*[^;]+(.*)?$/) !== null;
	const cookieBannerMenuItems = [].slice.call(banner.querySelectorAll('.js-cookie-banner-menu-item'));
	const cookieBannerTabItems = [].slice.call(banner.querySelectorAll('.js-cookie-banner-tab-item'));
	const cookieBannerCheckboxes = [].slice.call(banner.querySelectorAll('.js-cookie-checkbox'));
	const cookieBannerContent = banner.querySelector('.js-cookie-banner-content');

	function changeTab(e) {
		e.preventDefault();
		cookieBannerMenuItems.forEach(item => {
			item.classList.remove('cookie-banner__menu-item_active');
			if (item === e.target) {
				item.classList.add('cookie-banner__menu-item_active');
			}
		});
		cookieBannerTabItems.forEach(tabItem => {
			if (tabItem.getAttribute('data-tab') === this.getAttribute('data-tab')) {
				tabItem.classList.add('cookie-banner__tab-item_active');
			} else {
				tabItem.classList.remove('cookie-banner__tab-item_active');
			}
		});
	}

	if (banner) {
		if (!cookieBannerVisible) {
			banner.style.display = 'block';
		}

		closeBtn.addEventListener('click', e => {
			e.preventDefault();
			const consent = {};

			cookieBannerCheckboxes.forEach(checkbox => {
				consent[checkbox.value] = checkbox.checked;
			});

			const now = new Date();
			const time = now.getTime();
			const expireTime = time + (1000 * 60 * 60 * 24 * 365);

			now.setTime(expireTime);

			document.cookie = 'CookieConsent=' + JSON.stringify(consent) + '; expires=' + now.toUTCString() + '; path=/';
			banner.style.display = 'none';
			// window.location.reload();
		});

		triggerBtn.addEventListener('click', () => {
			cookieBannerContent.classList.toggle('cookie-banner__content_open');
			triggerBtn.classList.toggle('cookie-banner__btn_active');
			triggerBtn.textContent = cookieBannerContent.classList.contains('cookie-banner__content_open') ? 'Hide' : 'Details';
		});

		cookieBannerMenuItems.forEach(item => {
			item.addEventListener('click', changeTab, false);
		});
	}
});
